import { format } from 'date-fns';

export const dateFormat = (date, options) => {

    if (!date)
        return date

    // Backend retorna horário local do Brasil com sufixo Z (incorreto).
    // Removemos o designador de timezone para o browser não converter para UTC-3.
    const dateStr = typeof date === 'string'
        ? date.replace('Z', '').replace(/[+-]\d{2}:\d{2}$/, '')
        : date

    const date2 = new Date(dateStr)

    let { pattern } = { pattern: "dd/MM/yyyy HH:mm:ss", ...options }

    let formated = format(date2, pattern)

    return formated
}

export const secondsToTimeString = (totalSeconds) => {
  if (!totalSeconds && totalSeconds !== 0) return "--:--"

  const secNum = Math.round(Math.max(0, totalSeconds))
  const h = Math.floor(secNum / 3600).toString().padStart(2, '0')
  const m = Math.floor((secNum % 3600) / 60).toString().padStart(2, '0')
  const s = Math.floor(secNum % 60).toString().padStart(2, '0')

  return `${h}:${m}:${s}`
}

export const parseDbStringSeconds = (str) => {
  if (!str) return null
  if (typeof str !== 'string') return null
  if (str.includes('-')) return null

  const parts = str.split(':')
  if (parts.length !== 3) return null

  return (+parts[0]) * 3600 + (+parts[1]) * 60 + (+parts[2])
}